var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled, useTheme } from "@mui/material";
var StyledTableCellRow = styled(TableCell)(function (_a) {
    var theme = _a.theme;
    return ({
        border: "none",
        background: "#555",
    });
});
// component check list:
//   - simple api (props component interface) with clear responsability? yes
//   - sx at root element for style overrides: yes
//   - responsive: yes
//   - stories written for edge cases and as form of documentation: yes
//   - light theme support: not yet
function GetVTTableBasicWithRowObjectType() {
    function VTBasicTable(_a) {
        var sx = _a.sx, tableData = _a.tableData, _b = _a.showId, showId = _b === void 0 ? false : _b;
        var theme = useTheme();
        var columnNames = Object.keys(tableData[0]);
        if (!showId) {
            var indexOfId = columnNames.indexOf("id");
            columnNames.splice(indexOfId, indexOfId + 1);
        }
        var idVals = tableData.map(function (row) { return row.id; });
        return (_jsx(TableContainer, __assign({ sx: __assign(__assign({}, sx), { borderRadius: "20px" }) }, { children: _jsxs(Table, __assign({ sx: { borderCollapse: "separate", borderSpacing: "2px" } }, { children: [_jsx(TableHead, __assign({ sx: { background: theme.palette.primary.light } }, { children: _jsx(TableRow, { children: columnNames.map(function (columnName) {
                                var isCammelCaseColumnName = !!columnName.match(/[A-Z]/g);
                                var formattedColumnName = null;
                                if (isCammelCaseColumnName) {
                                    var spaceFormattedMultiWordColumnName = columnName.replace(/[A-Z]/g, function (textToReplace) {
                                        return " " +
                                            textToReplace.toUpperCase();
                                    });
                                    formattedColumnName =
                                        spaceFormattedMultiWordColumnName
                                            .substring(0, 1)
                                            .toUpperCase() +
                                            spaceFormattedMultiWordColumnName.substring(1, spaceFormattedMultiWordColumnName.length);
                                }
                                else {
                                    formattedColumnName =
                                        columnName
                                            .substring(0, 1)
                                            .toUpperCase() +
                                            (columnName.length > 1
                                                ? columnName
                                                    .substring(1, columnName.length)
                                                    .toLowerCase()
                                                : "");
                                }
                                return (_jsx(TableCell, __assign({ sx: {} }, { children: formattedColumnName })));
                            }) }) })), _jsx(TableBody, { children: tableData.map(function (row, i) {
                            var rowValuesAsArr = Object.values(row);
                            return (_jsx(TableRow, __assign({ sx: {} }, { children: !showId
                                    ? rowValuesAsArr
                                        .filter(function (dataColumn) {
                                        return !idVals.includes(dataColumn);
                                    })
                                        .map(function (dataColumn) { return (_jsx(StyledTableCellRow, __assign({ component: "th", scope: "row" }, { children: String(dataColumn) }))); })
                                    : rowValuesAsArr.map(function (dataColumn) { return (_jsx(StyledTableCellRow, __assign({ component: "th", scope: "row" }, { children: String(dataColumn) }))); }) }), row.id));
                        }) })] })) })));
    }
    return VTBasicTable;
}
export var VTBasicTableEmployees = GetVTTableBasicWithRowObjectType();
export var VTBasicTableStudents = GetVTTableBasicWithRowObjectType();
